import 'react';

import styled from '@emotion/styled';

interface BodyStyleProps {
  flex?: boolean;
}

export default styled('div')<BodyStyleProps>`
  padding: 30px;
  flex-grow: 1;
  ${(props) => (props.flex ? 'display: flex;' : '')}
`;
